import {
  CREATE_JOB_LIST_FAIL,
  CREATE_JOB_LIST_REQUEST,
  CREATE_JOB_LIST_SUCCESS,
  GET_APPLICANT_LIST_FAIL,
  GET_APPLICANT_LIST_REQUEST,
  GET_APPLICANT_LIST_SUCCESS,
  GET_JOB_DETAIL_FAIL,
  GET_JOB_DETAIL_REQUEST,
  GET_JOB_DETAIL_SUCCESS,
  GET_JOB_LIST_FAIL,
  GET_JOB_LIST_REQUEST,
  GET_JOB_LIST_SUCCESS,
  GET_SKILL_LIST_FAIL,
  GET_SKILL_LIST_REQUEST,
  GET_SKILL_LIST_SUCCESS,
} from "../../Constants/CareerConstants";

const initialStateDefault = {
  status: false,
  data: null,
  loading: true,
  error: null,
};

export const JobListReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_JOB_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_JOB_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_JOB_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const JobCreateReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === CREATE_JOB_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === CREATE_JOB_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === CREATE_JOB_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const SkillsListReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_SKILL_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_SKILL_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_SKILL_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const JobDetailReducer = (state = initialStateDefault, action: any) => {
  try {
    if (action.type === GET_JOB_DETAIL_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_JOB_DETAIL_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_JOB_DETAIL_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};

export const JobApplicantsListReducer = (
  state = initialStateDefault,
  action: any
) => {
  try {
    if (action.type === GET_APPLICANT_LIST_REQUEST) {
      return {
        ...state,
        loading: true,
      };
    }

    if (action.type === GET_APPLICANT_LIST_SUCCESS) {
      return {
        ...state,
        status: true,
        loading: false,
        data: action.data,
      };
    }
    if (action.type === GET_APPLICANT_LIST_FAIL) {
      return {
        ...state,
        status: false,
        loading: false,
        data: action.data,
      };
    }
  } catch (error) {}
  return state;
};
